// Sync clash UI: Framework7 Keep phone / Keep server dialog.
import { f7 } from "framework7-react";
import _ from "lodash";
import { getConflicts } from "./outbox";

export const askKeepPhoneOrServer = (label) =>
  new Promise((resolve) => {
    if (!f7?.dialog) {
      // App not mounted yet — default keep phone; user can re-open from notification
      resolve("phone");
      return;
    }
    f7.dialog
      .create({
        title: "Sync conflict",
        text: `${label || "This record"} was changed on the server while you were offline. Which version do you want to keep?`,
        buttons: [
          {
            text: "Keep server",
            onClick: () => resolve("server"),
          },
          {
            text: "Keep phone",
            bold: true,
            onClick: () => resolve("phone"),
          },
        ],
        verticalButtons: true,
      })
      .open();
  });

export const presentConflict = async ({ label }) => {
  return askKeepPhoneOrServer(label);
};

export const peekPendingConflict = async () => {
  const conflicts = await getConflicts();
  return _.isEmpty(conflicts) ? null : conflicts[0];
};
